import { ApplicationRef, ChangeDetectorRef, Component, NgZone, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MatDialog, MatDialogState } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MessageService, ErrorData } from 'src/app/services/message/message.service';
import { menuOptions } from 'src/data/menu-options.data';
import { HomeComponent } from '../../home/home.component';
import { ImportServiceV2 } from 'src/app/services/imports/import.service-v2';
import { CommonService } from 'src/app/services/common/common.service';
import { InfoDialogTwoComponent } from 'src/app/shared/components/info-dialog-two/info-dialog-two.component';
import { scheduleAppRefresh } from 'src/app/shared/utils/refresh-view';

@Component({
  selector: 'spe-importar-padrao-v2',
  templateUrl: './importar-padrao-v2.component.html',
  styleUrls: ['./importar-padrao-v2.component.scss'],
  standalone: false
})
export class ImportarPadraoV2Component implements OnInit {
  private dialogReference?: MatDialogRef<InfoDialogTwoComponent, any>;
  public message: string = '';
  public apiStatus: string | null = null;
  public alertMessage: string = 'Estamos processando seu arquivo. Aguarde';
  public alertTitle: string = 'Processando arquivo';
  public alertStatus: string | null = null;
  public showStepOne: boolean = true;
  public showStepTwo: boolean = false;
  public showStepSuccess: boolean = false;
  public showStepError: boolean = false;
  public showStepCounters: boolean = false;
  public showStepFail: boolean = false;
  public showStepAlert: boolean = false;
  public employees: number = 0;
  public benefits: number = 0;
  public errors: number = 0;
  public enableLoop: boolean = true;
  private idImportacao?: number;
  private subscriptions: Subscription[] = [];
  private idClientGroup = localStorage.getItem('idGrupoCliente');
  public errorsToShow: any[] = [];

  @ViewChild('createDialogTemplate') createDialogTemplate: TemplateRef<any> | undefined;

  constructor(
    public dialog: MatDialog,
    public readonly routerService: Router,
    private messageService: MessageService,
    private homeComponent: HomeComponent,
    public readonly importService: ImportServiceV2,
    public readonly commonService: CommonService,
    private cdr: ChangeDetectorRef,
    private appRef: ApplicationRef,
    private ngZone: NgZone
  ) {
    let extrasState = this.routerService.getCurrentNavigation()?.extras.state;
    if (extrasState != null) {
      let success = extrasState['success'];
      if (success != null && success === true) {
        this.showStepOne = false;
        this.showStepSuccess = true;
        this.alertTitle = 'Arquivo processado';
        this.showAlertMessage('Arquivo importado com sucesso.');
      }
    }
  }

  public importResume = () => {
    const url = this.routerService.serializeUrl(this.routerService.createUrlTree([`resumo-itens-importados`]));
    window.open(url, '_blank');
  };

  public novaImportacao = () => {
    this.showStepOne = true;
    this.showStepAlert = false;
    this.showStepError = false;
    this.showStepTwo = false;
    this.showStepSuccess = false;
    this.showStepFail = false;
    this.showStepCounters = false;
    this.refreshView();
  };

  private refreshView(): void {
    this.cdr.detectChanges();
    scheduleAppRefresh(this.appRef, this.ngZone);
  }

  public filesDataForm = new FormGroup({
    importFile: new FormControl('')
  });

  get filesDataFormControl() {
    return this.filesDataForm.controls;
  }

  ngOnInit(): void {
    const messageSubscription = this.messageService.errorData$.subscribe((errorData: ErrorData) => {
      this.showMessage(errorData.errorMessage, errorData.isError);
    });
    this.subscriptions.push(messageSubscription);
    this.homeComponent.setNewVariables(
      'Importação APB (Arquivo Padrão de Benefícios)',
      `Neste módulo você pode importar o arquivo no formato APB, trazendo as informações da sua folha de pagamento e atualizando no site. Se sua empresa já possui arquivo neste formato, indique abaixo sua localização.`,
      'importacao/importar-arquivo'
    );
    this.homeComponent.idleMenuContent = menuOptions[3].content;
  }

  ngOnDestroy(): void {
    this.enableLoop = false;
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  onChangeFile(event: any) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.filesDataForm.patchValue({
        importFile: file
      });
    }
  }

  public readonly openImportDialog = () => {
    let file: any = this.filesDataFormControl.importFile.value;
    let fileName: string = '';

    if (file != '') {
      fileName = file['name'];
    }
    fileName = fileName.toLowerCase();

    if (this.filesDataFormControl.importFile.value == '') {
      this.dialogReference = this.dialog.open(InfoDialogTwoComponent, {
        width: '332px',
        data: {
          title: 'Arquivo não aceito',
          message: 'Informe o arquivo que será importado.'
        }
      });
    } else if (fileName.length > 3 && fileName.slice(-3) != 'txt') {
      this.dialogReference = this.dialog.open(InfoDialogTwoComponent, {
        width: '332px',
        data: {
          title: 'Arquivo não aceito',
          message: 'Apenas arquivos com a extensão .txt são permitidos no upload.'
        }
      });
    } else {
      let file: any = this.filesDataFormControl.importFile.value;
      localStorage.setItem('fileName', file['name']);
      this.showAlertMessage('Iniciando processamento do arquivo, aguarde...');
      this.homeComponent.setNewVariables('', '');
      const subscription = this.importService
        .iniciarProcessamento('S', this.filesDataFormControl.importFile.value)
        .subscribe({
          next: (data) => {
            this.showStepOne = false;
            this.showStepTwo = true;
            this.idImportacao = data;
            this.refreshView();
            this.importStatus(data);
          },
          error: (e) => {
            let errorMensagem: string = e.error.mensagem;
            if (errorMensagem.includes('Foi encontrado o seguinte erro')) {
              this.showAlertMessage('Foi encontrado o seguinte erro na importação');
              let splitString = errorMensagem.split('<br><br>');
              for (let index = 1; index < splitString.length; index++) {
                this.errorsToShow.push(splitString[index]);
              }
            } else if (errorMensagem.includes('Foram encontrados os seguintes erros na importação')) {
              this.showAlertMessage('Foram encontrados os seguintes erros na importação');
              let splitString = errorMensagem.split('<br><br>');
              for (let index = 1; index < splitString.length; index++) {
                this.errorsToShow.push(splitString[index]);
              }
            } else {
              this.showAlertMessage(errorMensagem);
            }
            this.apiStatus = null;
            this.showStepOne = false;
            this.showStepAlert = true;
            this.refreshView();
          }
        });
      this.subscriptions.push(subscription);
    }
  };

  private readonly importStatus = (idImportacao: string) => {
    const subscription = this.importService.consultarStatusDeProcessamentoDaImportacao(idImportacao).subscribe({
      next: (data) => {
        this.showStepOne = false;
        this.showStepTwo = true;

        if (
          data.quantidadeEmpresas == 0 &&
          data.quantidadeEnderecos == 0 &&
          data.quantidadeFuncionarios == 0 &&
          data.quantidadeBeneficios == 0 &&
          data.quantidadeErros > 0 &&
          data.id == 1
        ) {
          this.homeComponent.setNewVariables('Importação Padrão', ``, 'importacao/importar-arquivo');
          this.showStepError = true;
          this.showAlertMessage(
            'Foram encontrados inconsistências na importação do seu arquivo. Clique no botão abaixo para verificar e corrigir os dados.',
            true
          );
          this.showStepTwo = false;
          this.refreshView();
          return;
        } else if (
          data.quantidadeEmpresas > 0 ||
          data.quantidadeEnderecos > 0 ||
          data.quantidadeFuncionarios > 0 ||
          data.quantidadeBeneficios > 0 ||
          data.id > 1
        ) {
          this.showAlertMessage('Estamos processando o seu arquivo, aguarde...');
          this.showStepCounters = true;
          this.employees = data.quantidadeFuncionarios;
          this.benefits = data.quantidadeBeneficios;
          this.errors = data.quantidadeErros;
          if (data.id > 0) {
            this.showStepCounters = false;
            if (data.id == 9) {
              this.homeComponent.setNewVariables('Importação Padrão', ``, 'importacao/importar-arquivo');
              this.showAlertMessage('Arquivo não processado por erros. Por favor, tente novamente.');
              this.showStepOne = true;
              this.showStepTwo = false;
            } else {
              this.showAlertMessage('Finalizando, aguarde...');
              this.importProcess(idImportacao);
            }
          } else {
            setTimeout(() => {
              if (this.enableLoop) {
                this.importStatus(idImportacao);
              }
            }, 20000);
          }
        } else if (
          data.quantidadeEmpresas == 0 &&
          data.quantidadeEnderecos == 0 &&
          data.quantidadeFuncionarios == 0 &&
          data.quantidadeBeneficios == 0 &&
          data.quantidadeErros == 0 &&
          data.id == 0
        ) {
          setTimeout(() => {
            if (this.enableLoop) {
              this.importStatus(idImportacao);
            }
          }, 20000);
        }
        this.refreshView();
      },
      error: () => {
        this.homeComponent.setNewVariables('Importação Padrão', ``, 'importacao/importar-arquivo');
        this.showMessage('Arquivo não processado por erros. Por favor, tente novamente.');
        this.showStepOne = true;
        this.showStepTwo = false;
        this.refreshView();
      }
    });
    this.subscriptions.push(subscription);
  };

  private readonly importProcess = (idImportacao: string) => {
    let body = { idImportacao: idImportacao, flagExtrairErroParaTratamento: 'N' };
    const subscription = this.importService.finalizarProcessamento(this.idClientGroup!, body).subscribe({
      next: (data) => {
        if (data == null) {
          this.homeComponent.setNewVariables('', ``);
          this.concluirImportacao(idImportacao);
        } else {
          this.showStepTwo = false;
          this.showStepError = true;
          this.alertTitle = 'Validação de dados';
          this.homeComponent.setNewVariables('Importação Padrão', ``, 'importacao/importar-arquivo');
          this.showAlertMessage(
            'Foram encontrados inconsistências na importação do seu arquivo. Clique no botão abaixo para verificar e corrigir os dados.',
            true
          );
        }
        this.refreshView();
      },
      error: (e) => {
        this.showStepTwo = false;
        this.showStepFail = true;
        this.alertStatus = null;
        this.homeComponent.setNewVariables('Importação Padrão', ``, 'importacao/importar-arquivo');
        this.showMessage(
          `Erro na execução da importação. Contate a Central de Atendimento e informe o erro [4 ${e.error.mensagem}`
        );
        this.refreshView();
      }
    });
    this.subscriptions.push(subscription);
  };

  private concluirImportacao = (idImportacao: string) => {
    const subscription = this.importService.concluirImportacao(this.idClientGroup!, idImportacao).subscribe({
      next: () => {
        this.consultarAndamento(idImportacao);
      },
      error: (e) => {
        this.showStepTwo = false;
        this.showStepAlert = true;
        let errorMensagem: string = e.error.mensagem;
        this.homeComponent.setNewVariables('Importação Padrão', ``, 'importacao/importar-arquivo');
        this.showAlertMessage('Erro na geração da importação.');
        this.errorsToShow.push(`Contate a Central de Atendimento e informe o erro [5 ${errorMensagem}`);
        this.refreshView();
      }
    });
    this.subscriptions.push(subscription);
  };

  private consultarAndamento = (idImportacao: string) => {
    const subscription = this.importService.consultarAndamentoConclusao(this.idClientGroup!, idImportacao).subscribe({
      next: (d) => {
        if (d.importacaoControle.flagStatus == 'C') {
          this.showStepTwo = false;
          this.showStepSuccess = true;
          this.alertTitle = 'Importado';
          this.showAlertMessage('Arquivo importado com sucesso.');
          this.homeComponent.setNewVariables('Importação Padrão', ``, 'importacao/importar-arquivo');
        } else if (d.importacaoControle.flagStatus == 'E' || d.importacaoControle.flagStatus == 'F') {
          this.showStepTwo = false;
          this.showStepAlert = true;
          this.showMessage(`${d.importacaoControle.codigoDoErro} - ${d.importacaoControle.descricaoDoErro}`);
          this.homeComponent.setNewVariables('Importação Padrão', ``, 'importacao/importar-arquivo');
          this.commonService.autoScroll();
        } else if (d.importacaoControle.flagStatus == 'P') {
          setTimeout(() => {
            if (this.enableLoop) {
              this.consultarAndamento(idImportacao);
            }
          }, 20000);
        } else {
          this.showStepTwo = false;
          this.showStepAlert = true;
          this.homeComponent.setNewVariables('Importação Padrão', ``, 'importacao/importar-arquivo');
          this.showMessage(`Algo deu errado ao concluir a importação`);
          this.commonService.autoScroll();
        }
        this.refreshView();
      },
      error: (e) => {
        this.showStepAlert = true;
        this.showStepTwo = false;
        this.homeComponent.setNewVariables('Importação Padrão', ``, 'importacao/importar-arquivo');
        this.commonService.autoScroll();
        this.refreshView();
      }
    });
    this.subscriptions.push(subscription);
  };

  private readonly confirmDialogConfig = (title: string, message: string): Object => {
    const data = {
      title: title,
      component: this.createDialogTemplate,
      confirmAction: this.closeDialog,
      message: message,
      confirm: 'Localizar arquivo',
      file: this.filesDataFormControl.importFile
    };
    return { panelClass: 'full-bleed-dialog', width: '600px', data: data };
  };

  private readonly closeDialog = () => {
    if (this.dialogReference && this.dialogReference.getState() === MatDialogState.OPEN) {
      this.dialogReference.afterClosed().subscribe((result) => {
        this.filesDataForm.patchValue({
          importFile: result
        });
        document.getElementById('customFileLabel')!.innerHTML = result.name;
      });
      this.dialogReference.close();
    }
  };

  public readonly goTo = () => {
    this.routerService.navigate([`home/importacao/importar-arquivo/verificar-dados-importados/${this.idImportacao}`], {
      queryParams: { tipo: 'padrao' }
    });
  };

  private readonly showMessage = (text: string = '', errorMessage: boolean = false) => {
    this.apiStatus = errorMessage ? 'error' : 'success';
    this.message = text;
  };

  private readonly showAlertMessage = (text: string = '', errorMessage: boolean = false) => {
    this.alertStatus = errorMessage ? 'error' : 'success';
    this.alertMessage = text;
  };
}
